// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import { formatDate, formatCurrency } from "utils";

// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftDatePicker from "components/SoftDatePicker";

// NewUser page components
import { useNavigate, useParams } from "react-router-dom";
import FormField from "components/FormField";
import SoftEditor from "components/SoftEditor";
import { useEffect, useState } from "react";
import Products from "./product";
import { InvoiceBooksService } from "services/invoiceBooksService";
import TableDN from "../components/table-dn";
import { CompanyService } from "services/companyService";
import { AuthService } from "services/authService";
function BillInfo({ formData }) {
  const { formField, values, errors, touched, getData, onChangeValue, setFieldValue } = formData;
  const {
    sellerName,
    sellerTaxCode,
    sellerPhone,
    sellerAddress,
    sellerBankAccount,
    buyerName,
    buyerTaxCode,
    buyerAddress,
    buyerBankAccount,
    day,
    payments,
    currency,
    invoiceSymbol,
    number,
  } = formField;
  const {
    sellerName: sellerNameV,
    sellerTaxCode: sellerTaxCodeV,
    sellerPhone: sellerPhoneV,
    sellerAddress: sellerAddressV,
    sellerBankAccount: sellerBankAccountV,
    buyerName: buyerNameV,
    buyerTaxCode: buyerTaxCodeV,
    buyerAddress: buyerAddressV,
    buyerBankAccount: buyerBankAccountV,
    day: dayV,
    payments: paymentsV,
    currency: currencyV,
    invoiceSymbol: invoiceSymbolV,
    number: numberV,
  } = values;

  const { id } = useParams();
  const currentPath = window.location.pathname;
  const containsEdit = currentPath.includes("edit");
  const containsCreate = currentPath.includes("create");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [date, setDate] = useState();

  const [totalNoTax, setTotalNoTax] = useState(0);
  const [totalVAT, setTotalVAT] = useState(0);
  const [totalPaymentTax, setTotalPaymentTax] = useState(0);
  const [amountWords, setAmountWords] = useState("Không Đồng");

  const [invoiceSymbolD, setInvoiceSymbolD] = useState("");
  const [numberD, setNumberD] = useState(0);

  useEffect(() => {
    if (Object.keys(getData).length > 0) {
      setFieldValue(sellerName.name, getData.sellerName);
      setFieldValue(sellerTaxCode.name, getData.sellerTaxCode);
      setFieldValue(sellerPhone.name, getData.sellerPhone);
      setFieldValue(sellerAddress.name, getData.sellerAddress);
      setFieldValue(sellerBankAccount.name, getData.sellerBankAccount);
      setFieldValue(buyerName.name, getData.buyerName);
      setFieldValue(buyerTaxCode.name, getData.buyerTaxCode);
      setFieldValue(buyerAddress.name, getData.buyerAddress);
      setFieldValue(buyerBankAccount.name, getData.buyerBankAccount);
      setFieldValue(payments.name, getData.payments);
      setFieldValue(currency.name, getData.currency);
      setFieldValue(invoiceSymbol.name, getData.invoiceSymbol);
      setFieldValue(number.name, getData.number);
      setFieldValue(currency.name, getData.currency);
      setFieldValue(day.name, getData.day);
      setDate(new Date(getData.day));
    }
  }, [containsEdit, getData]);

  useEffect(() => {
    (async () => {
      const { data } = await InvoiceBooksService.getCompanyByAuth();
      setInvoiceSymbolD(data.invoiceSymbol);
      setNumberD(++data.used);
    })();
  }, [containsEdit, getData]);

  useEffect(() => {
    (async () => {
      const { data } = await CompanyService.getByAuth();
      // const { data } = await AuthService.getMe();
      setFieldValue(buyerName.name, data.name);
      setFieldValue(buyerTaxCode.name, data.taxCode);
      setFieldValue(buyerAddress.name, data.address);
      setFieldValue(buyerBankAccount.name, data.accountNumber);
    })();
  }, [containsCreate]);

  useEffect(() => {
    (async () => {
      await onChangeValue("products", products);
      await onChangeValue("totalPaymentTax", totalPaymentTax);
    })();
  }, [products]);

  const handleSetDate = (newDate) => {
    const time = new Date(newDate[0]).getTime();
    setDate(newDate);
    onChangeValue("day", time);
  };

  if (id && containsEdit && (!getData || Object.keys(getData).length === 0)) {
    return <>Loading...</>;
  }
  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        {!id && !containsEdit ? (
          <SoftTypography variant="h5" fontWeight="bold">
            Tạo hóa đơn đầu vào
          </SoftTypography>
        ) : (
          <SoftTypography variant="h5" fontWeight="bold">
            Chi tiết hóa đơn đầu vào
          </SoftTypography>
        )}
      </SoftBox>
      {(id && containsEdit) || (!id && !containsEdit) ? (
        <>
          <SoftBox mt={6}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={invoiceSymbol.type}
                  label={invoiceSymbol.label}
                  name={invoiceSymbol.name}
                  value={invoiceSymbolV}
                  placeholder={invoiceSymbol.placeholder}
                  // error={errors.invoiceSymbol && touched.invoiceSymbol}
                  // success={invoiceSymbolV.length > 0 && !errors.invoiceSymbol}
                  // disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={number.type}
                  label={number.label}
                  name={number.name}
                  value={numberV}
                  placeholder={number.placeholder}
                  // error={errors.number && touched.number}
                  // success={numberV.length > 0 && !errors.number}
                  // disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                {id && !containsEdit ? (
                  <FormField
                    type={payments.type}
                    label={payments.label}
                    name={payments.name}
                    value={paymentsV === "cash" ? "Tiền mặt" : "Chuyển khoản"}
                    placeholder={payments.placeholder}
                    // error={errors.payments && touched.payments}
                    // success={paymentsV.length > 0 && !errors.payments}
                    disabled={id && !containsEdit}
                  />
                ) : (
                  <>
                    <SoftBox display="flex" flexDirection="column">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        mb={0.9}
                        mt={1.6}
                      >
                        {payments.label}
                      </SoftTypography>
                      <SoftSelect
                        isLoading={loading}
                        onChange={(e) => onChangeValue("payments", e.value)}
                        defaultValue={{
                          value: id && containsEdit && getData?.payments ? getData?.payments : "",
                          label:
                            id && containsEdit && getData?.payments
                              ? getData?.payments === "cash"
                                ? "Tiền mặt"
                                : "Chuyển khoản"
                              : "Chọn",
                        }}
                        options={[
                          { value: "cash", label: "Tiền mặt" },
                          { value: "transfer", label: "Chuyển khoản" },
                        ]}
                      />
                    </SoftBox>
                  </>
                )}
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                {id && !containsEdit ? (
                  <FormField
                    type={currency.type}
                    label={currency.label}
                    name={currency.name}
                    value={currencyV}
                    placeholder={currency.placeholder}
                    // error={errors.currency && touched.currency}
                    // success={currencyV.length > 0 && !errors.currency}
                    disabled={id && !containsEdit}
                  />
                ) : (
                  <>
                    <SoftBox display="flex" flexDirection="column">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        mb={0.9}
                        mt={1.6}
                      >
                        {currency.label}
                      </SoftTypography>
                      <SoftSelect
                        isLoading={loading}
                        onChange={(e) => onChangeValue("currency", e.value)}
                        defaultValue={{
                          value: id && containsEdit && getData?.currency ? getData.currency : "",
                          label: id && containsEdit && getData?.currency ? getData.currency : "",
                        }}
                        options={[
                          {
                            value: "VND",
                            label: "VND",
                          },
                          {
                            value: "USD",
                            label: "USD",
                          },
                        ]}
                      />
                    </SoftBox>
                  </>
                )}
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                {id && !containsEdit ? (
                  <FormField
                    type={"text"}
                    label={day.label}
                    name={day.name}
                    value={date ? formatDate(date) : ""}
                    placeholder={day.placeholder}
                    // error={errors.day && touched.day}
                    // success={dayV.length > 0 && !errors.day}
                    disabled={id && !containsEdit}
                  />
                ) : (
                  <>
                    <SoftBox display="flex" flexDirection="column">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        mb={0.9}
                        mt={1.8}
                      >
                        {day.label}
                      </SoftTypography>
                      <SoftDatePicker
                        options={{
                          noCalendar: false,
                          enableTime: false,
                          dateFormat: "d-m-Y",
                        }}
                        value={date}
                        onChange={handleSetDate}
                      />
                    </SoftBox>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} style={{ paddingTop: "30px" }}>
                <FormField
                  type={sellerName.type}
                  label={sellerName.label}
                  name={sellerName.name}
                  value={sellerNameV}
                  placeholder={sellerName.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.sellerName && touched.sellerName}
                  // success={sellerNameV.length > 0 && !errors.sellerName}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "30px" }}>
                <FormField
                  type={sellerTaxCode.type}
                  label={sellerTaxCode.label}
                  name={sellerTaxCode.name}
                  value={sellerTaxCodeV}
                  placeholder={sellerTaxCode.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.sellerTaxCode && touched.sellerTaxCode}
                  // success={sellerTaxCodeV.toString().length > 0 && !errors.sellerTaxCode}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={sellerPhone.type}
                  label={sellerPhone.label}
                  name={sellerPhone.name}
                  value={sellerPhoneV}
                  placeholder={sellerPhone.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.sellerPhone && touched.sellerPhone}
                  // success={sellerPhoneV.length > 0 && !errors.sellerPhone}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={sellerAddress.type}
                  label={sellerAddress.label}
                  name={sellerAddress.name}
                  value={sellerAddressV}
                  placeholder={sellerAddress.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.sellerAddress && touched.sellerAddress}
                  // success={sellerAddressV.toString().length > 0 && !errors.sellerAddress}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={sellerBankAccount.type}
                  label={sellerBankAccount.label}
                  name={sellerBankAccount.name}
                  value={sellerBankAccountV}
                  placeholder={sellerBankAccount.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.sellerBankAccount && touched.sellerBankAccount}
                  // success={sellerBankAccountV.toString().length > 0 && !errors.sellerBankAccount}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} style={{ paddingTop: "20px" }}>
                <FormField
                  type={buyerName.type}
                  label={buyerName.label}
                  name={buyerName.name}
                  value={buyerNameV}
                  placeholder={buyerName.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.buyerName && touched.buyerName}
                  // success={buyerNameV.length > 0 && !errors.buyerName}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "20px" }}>
                <FormField
                  type={buyerTaxCode.type}
                  label={buyerTaxCode.label}
                  name={buyerTaxCode.name}
                  value={buyerTaxCodeV}
                  placeholder={buyerTaxCode.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.buyerTaxCode && touched.buyerTaxCode}
                  // success={buyerTaxCodeV.toString().length > 0 && !errors.buyerTaxCode}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={buyerAddress.type}
                  label={buyerAddress.label}
                  name={buyerAddress.name}
                  value={buyerAddressV}
                  placeholder={buyerAddress.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.buyerAddress && touched.buyerAddress}
                  // success={buyerAddressV.toString().length > 0 && !errors.buyerAddress}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
                <FormField
                  type={buyerBankAccount.type}
                  label={buyerBankAccount.label}
                  name={buyerBankAccount.name}
                  value={buyerBankAccountV}
                  placeholder={buyerBankAccount.placeholder}
                  disabled={id && !containsEdit}
                  // error={errors.buyerBankAccount && touched.buyerBankAccount}
                  // success={buyerBankAccountV.toString().length > 0 && !errors.buyerBankAccount}
                />
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox mt={6}>
            <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
              Danh sách sản phẩm
            </Grid>
          </SoftBox>
          <SoftBox mt={6}>
            <Products
              formData={{
                getData,
                setProducts,
                setTotalNoTax,
                setTotalVAT,
                setTotalPaymentTax,
                setAmountWords,
              }}
            />
          </SoftBox>
          <SoftBox>
            <SoftTypography variant="h6" fontWeight="bold">
              {`Tổng tiền chưa có thuế GTGT: ` + formatCurrency.format(totalNoTax)}
            </SoftTypography>
            <SoftTypography variant="h6" fontWeight="bold">
              {`Tổng tiền thuế GTGT theo từng loại thuế suất: ` + formatCurrency.format(totalVAT)}
            </SoftTypography>
            <SoftTypography variant="h6" fontWeight="bold">
              {`Tổng tiền thanh toán đã có thuế GTGT: ` + formatCurrency.format(totalPaymentTax)}
            </SoftTypography>
            <SoftTypography variant="h6" fontWeight="bold">
              {`Số tiền viết bằng chữ: ` + amountWords}
            </SoftTypography>
          </SoftBox>
        </>
      ) : (
        <>
          <TableDN data={getData} />
        </>
      )}
    </SoftBox>
  );
}

// typechecking props for BillInfo
BillInfo.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default BillInfo;
